import { data } from 'jquery';
import { RegistrationFormComponent } from './../registration-form/registration-form.component';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Inject } from '@angular/core';
import { PatientService } from 'src/app/basic-data/services/patient.service';
import { Globals } from 'src/app/shared/services/globals';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../services/user.service';
import { UserManagerService } from 'src/app/shared/services/user-manager.service';

@Component({
  selector: 'app-activation-user',
  templateUrl: './activation-user.component.html',
  styleUrls: ['./activation-user.component.css']
})
export class ActivationUserComponent implements OnInit {

  userId: any;
  patient: any;
  ActiveForm: FormGroup;
  submitted: boolean = false;
  constructor(public dialogRef: MatDialogRef<RegistrationFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private toastr: ToastrService,
    private userService: UserService,private _PatientService: PatientService, private userManger: UserManagerService,public global: Globals) {
    this.userId = data.userid
    this.ActiveForm = this.createFormGroup()

  }
  createFormGroup() {
    return new FormGroup({
      RondumNumber: new FormControl('', [
        Validators.required, Validators.maxLength(4), Validators.minLength(4)
      ])
    }
    )
  }
  reset() {
    this.submitted = false;
    this.ActiveForm.reset();
  }
  get f() { return this.ActiveForm.controls; }


  ngOnInit() {
    this.global.spinner = true;
    this._PatientService.getPatientById(this.userId).subscribe(
      (data: any) => {
        console.log(data);
        if (data.status != -1) {
          this.patient = data.data;
          this.global.spinner = false;
          console.log(this.patient ,'ggggg')
          if(this.patient.isActive == false && this.patient.randomNumber =="1"){
            this.toastr.error(" هذا الحساب غير مفعل ")
            this.dialogRef.close();

          }
        }
        else {
          this.toastr.error('لم يتم العثور على بيانات المستخدم');
          this.global.spinner = false;

        }
      },
      (error: any) => {
        console.log(error);
        this.toastr.error('حدث خطأ ما');
        this.global.spinner = false;

      }
    );


  }
  ActiveUser() {
    this.submitted = true;
    if (!this.ActiveForm.invalid) {
      const number = this.ActiveForm.controls.RondumNumber.value;
      console.log(number)
      if (this.patient.isActive == false) {
        console.log(this.patient.randomNumber)

        if (this.patient.randomNumber == number) {
          this.global.spinner = true;
          this._PatientService.ActivationPatient(this.userId).subscribe(
            (data: any) => {
              console.log(data);
              if(data.status !=-1){
                this.patient = data.data;
                this.global.spinner = false;
                this.global.Role = "PATIENT";
                this.login(data.email, data.password);
              }
              //this.router.navigate(['/landind']);
              this.router.navigateByUrl("/landind");
              this.dialogRef.close();

            },
            (error: any) => {
              console.log(error);
              this.toastr.error('حدث خطأ ما');
              this.global.spinner = false;

            }
          )
        }
       /* else if(this.patient.randomNumber =="1"){
          this.toastr.error("تم الغاء التفعيل")
          this.dialogRef.close();

        }*/
        else {
          this.toastr.error("خطأ..من فضلك ادخل الرقم الصحيح")
        }
      }
      else {
        this.global.Role = "PATIENT"
        this.router.navigate(['/landind']);
        this.dialogRef.close();


      }
    }
  }
  close(): void {
    this.router.navigateByUrl("");
    this.dialogRef.close();
  }

  login(email, password) {
      this.userService.login(email, password).subscribe(
        result => {
          if (result.status === 1) {
            // this.errors = false;
            this.userManger.logout();
            this.userManger.saveToken(result.data.token);
            this.userManger.saveUserData(result.data);
            this.userManger.login();
            this.global.EmpCompleteData = result.data.completeData;
            this.global.Role = result.data.roleCode[0];
            this.userId = result.data.userId;

            this.router.navigateByUrl("/landind");

          } else {
            this.global.spinner = false;
            if (result.messages) {
              this.global.Messages = result.messages;
              this.global.spinner = false;
            }
            this.global.spinner = false;
            this.global.Messages = null;
          }
          this.global.spinner = false;
        },
        error => {
          console.log(error);
          this.global.spinner = false;
        }
      );
  }
 }
